<div class="flex flex-col fill">
  @if(SHOW_RIBBON) {
  <div class="ribbon">
    <p>{{ ENVIRONMENT }}</p>
  </div>
  }
  <mic-header>
    <div class="flex flex-row items-center justify-between">
      <div class="flex flex-row flex-none items-center">
        <mic-sidebar-toggler [alwaysDisplay]="true" id="main-sidebar-toggler" type="left"></mic-sidebar-toggler>
        <a routerLink="/">
          <mic-logo></mic-logo>
        </a>
      </div>
      <mic-navbar-spacer></mic-navbar-spacer>
      <span class="title md-hidden">{{ title }}</span>
      <mic-navbar-spacer></mic-navbar-spacer>
      <div class="flex flex-row flex-none gap-2 items-center">
        <mic-navbar-links>
          <mic-navbar-link link="/contact" icon="alternate_email" label="Contact"></mic-navbar-link>
        </mic-navbar-links>
        <button mat-button [matMenuTriggerFor]="menu">
          <mic-icon icon="apps"> </mic-icon>
        </button>
        <mat-menu #menu="matMenu">
          @for (app of applications; track app.id) {
          <a (click)="onChangeApplication(app)" [routerLink]="'/' + app.name + '/csv'"
            ><button mat-menu-item>
              {{ app.name }}
            </button></a
          >
          }
        </mat-menu>
        <button mat-icon-button class="mic-icon-button-medium" aria-label="Set theme" (click)="setTheme()">
          <mat-icon>{{ darkMode ? 'light_mode' : 'bedtime' }}</mat-icon>
        </button>
      </div>
    </div>
  </mic-header>
  <mic-sidebar-container leftToggler="main-sidebar-toggler">
    @if (user !== undefined) {
    <mic-sidebar position="start">
      @if (selectedApp === 'HBI' && user.role !== 'simpleUser') {
      <mic-sidebar-item link="/" icon="people" label="Users"></mic-sidebar-item>
      } @if (selectedApp === 'HBI') {
      <mic-sidebar-item link="/applications" icon="important_devices" label="applications"></mic-sidebar-item>
      } @if (selectedApp === 'HBI' && user.role !== 'simpleUser') {
      <mic-sidebar-item link="/notifications" icon="notifications" label="notifications"></mic-sidebar-item>
      } @if (selectedApp !== 'HBI' && user.role !== 'simpleUser') {
      <mic-sidebar-item [link]="'/' + selectedApp + '/csv'" icon="file_download" label="Import CSV"></mic-sidebar-item>
      } @if (selectedApp !== 'HBI' && user.role !== 'simpleUser') {
      <mic-sidebar-item [link]="'/' + selectedApp + '/xlsx'" icon="file_download" label="Import XLSX"></mic-sidebar-item>
      } @if (selectedApp !== 'HBI' && user.role !== 'simpleUser') {
      <mic-sidebar-item [link]="'/' + selectedApp + '/repository'" icon="insights" label="Group"></mic-sidebar-item>
      } @if (selectedApp !== 'HBI' && user.role !== 'simpleUser') {
      <mic-sidebar-item [link]="'/' + selectedApp + '/tables'" icon="table_view" label="Tables"></mic-sidebar-item>
      } @if (selectedApp !== 'HBI' && user.role === 'Admin') {
      <mic-sidebar-item [link]="'/' + selectedApp + '/configuration'" icon="settings" label="Settings"></mic-sidebar-item>
      } @if (selectedApp !== 'HBI' && user.role === 'Admin') {
      <mic-sidebar-item [link]="'/' + selectedApp + '/audits'" icon="notifications_active" label="Audits"></mic-sidebar-item>
      }
      <mic-sidebar-item onKeyDown="onLogout()" (click)="onLogout()" icon="logout" label="Log Out" class="logout-style"></mic-sidebar-item>
      <mic-sidebar-spacer></mic-sidebar-spacer>
      <mic-sidebar-item link="/settings" icon="settings" label="Settings"></mic-sidebar-item>
    </mic-sidebar>
    }
    <mic-main-content main>
      <div class="flex flex-col fill justify-between" content>
        <div class="sidebar-container-content">
          <router-outlet></router-outlet>
        </div>
        <mic-footer>
          <div class="xs-self-center"></div>
          <div class="xs-self-center">Copyright Michelin © {{ year }}</div>
          <div class="version xs-self-center">Version {{ version }}</div>
        </mic-footer>
      </div>
    </mic-main-content>
  </mic-sidebar-container>
  <mic-alert-center [hideDelay]="8"></mic-alert-center>
</div>
